import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "../../../redux-store";

const selectEntities = (state: RootState) => state.data.equipment.entities;
const selectIds = (state: RootState) => state.data.equipment.ids;

export const selectEquipment = createSelector(
  selectIds,
  selectEntities,
  (ids, entities) => ids.map((id) => entities[id])
);

export const selectEquipmentById = (id?: string | null) => (state: RootState) =>
  !id ? undefined : state.data.equipment.entities[id];

export const selectEquipmentLoading = (state: RootState) =>
  state.data.equipment.loading;

export const selectEquipmentActiveRentalNumbers = (state: RootState) =>
  state.data.equipment.activeRentalNumbers;
